import React, { useEffect, useState } from 'react';
import './ImageSlider.css';

const ImageSlider = ({ images }) => {
  const [slideIndex, setSlideIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSlideIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 2000); // Change image every 2 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="slider-container">
      {images.map((image, index) => (
        <img
          key={index}
          src={image}
          alt={`Slide ${index}`}
          className={`mySlides ${index === slideIndex ? 'active' : ''}`}
        />
      ))}
    </div>
  );
};

export default ImageSlider;
